<template>
    <div class="l-learn-rule-container l-learn-exam-wrapper" v-if="element">
        <div class="l-learn-content-container l-learn-exam-top">
            <div class="l-learn-rule-main">
                <div class="l-learn-rule-title">考试规则说明</div>
                <p class="l-learn-rule-text">1. 闯关途中不可退出，不可更换设备；</p>
                <p class="l-learn-rule-text">
                    2. 限时
                    <span class="l-learn-rule-primary">
                        {{
                            element.attrs.examDuration
                        }}
                    </span>分钟；
                </p>
                <p class="l-learn-rule-text">3. 蓝思指数： <span class="l-learn-rule-primary">{{ element.attrs.lexile }}</span>；
                </p>
                <p class="l-learn-rule-text">4. AR指数：<span class="l-learn-rule-primary">{{ element.attrs.difficultLevel
                }}</span>；</p>
                <p class="l-learn-rule-text">5. 闯关时间截止后系统自动提交；</p>
                <p class="l-learn-rule-text">
                    6. 本次闯关共
                    <span class="l-learn-rule-primary">
                        {{
                            element.totalCount
                        }}
                    </span>小关，满分100分；
                </p>
                <p class="l-learn-rule-text">7. 闯关完成后，系统会根据战绩奖励LILY币；</p>
                <p class="l-learn-rule-text">
                    8. 仅有
                    <span class="l-learn-rule-primary">
                        {{
                            element.attrs.firstStudyNum + element.attrs.continueStudyNum
                        }}
                    </span>次闯关机会，中途退出后系统仍会继续计时；
                </p>
                <!--          <p class="l-learn-rule-text">-->
                <!--            7. 题库已申请版权，请勿拷贝，违者必究；-->
                <!--          </p>-->
                <p class="l-learn-rule-text">9. 为了保护眼睛，建议使用pad或者电脑端进行闯关；</p>
                <p class="l-learn-rule-text">10. 闯关内容已申请版权，请勿拷贝，违者必究；</p>
            </div>
            <!-- 按钮 -->
            <div class="l-learn-exam-btn-container l-learn-exam-bottom">
                <LButtonCommon :type="3" @select="onStart" />
            </div>
        </div>
    </div>
</template>

<script>
import LButtonCommon from '@/views/learn-new/components/l-button-common'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('course')

export default {
    name: 'l-learn-rule',
    components: { LButtonCommon },
    computed: {
        ...mapGetters(['element']),
    },
    methods: {
        onStart () {
            this.$emit('start', {
                isRule: true,
            })
        },
    },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>

